import { SimpleInput } from '@aloft/toolkit-sui';

export function AdjustPairsLabelInput({
  label: label,
  setLabel,
}: {
  label: string;
  setLabel: (label: string) => void;
}) {
  return (
    <SimpleInput
      value={label}
      variant="grid"
      size="xs"
      onChange={(e) => setLabel(e.currentTarget.value)}
    />
  );
}
